import { render, staticRenderFns } from "./Prestations.vue?vue&type=template&id=32c715df&scoped=true&"
import script from "./Prestations.vue?vue&type=script&lang=ts&"
export * from "./Prestations.vue?vue&type=script&lang=ts&"
import style0 from "./Prestations.vue?vue&type=style&index=0&id=32c715df&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32c715df",
  null
  
)

export default component.exports